<ul>
	<li [hasPublicationField]="'rootOnly'" [hasPermission]="['root', 'ad services']" routerLinkActive="active"><a [routerLink]="['/adservices/dashboard']"><i class="fa fa-chart-line-up"></i>{{ 'DASHBOARD' | translate }}</a></li>

	<li [hasPermission]="'ad services'" routerLinkActive="active"><a [routerLink]="['/adservices/adunits']"><i class="fa fa-caret-square-right"></i>{{ 'AD_UNITS' | translate }}</a></li>

	<li [hasPermission]="'ad services'" routerLinkActive="active"><a [routerLink]="['/adservices/lineitems']"><i class="fa fa-th-list"></i>{{ 'LINE_ITEMS' | translate }}</a></li>

	<li [hasPermission]="'ad services'" [ngClass]="{'active': activeLink === 'position'}"><a [routerLink]="['/adservices/positions']"><i class="fa fa-columns"></i>{{ 'POSITIONS' | translate }}</a></li>
	
	<li [hasPermission]="'adschedules'" [ngClass]="{'active': activeLink === 'adschedule'}"><a [routerLink]="['/adservices/adschedules']"><i class="fa fa-bars-staggered"></i>{{ 'AD_SCHEDULES' | translate }}</a></li>

	<li [hasPermission]="'auctions'" [ngClass]="{'active': activeLink === 'auction'}"><a [routerLink]="['/adservices/auctions']"><i class="fa fa-gavel"></i>{{ 'AUCTIONS' | translate }}</a></li>

	<li [hasPermission]="'ad services'" [ngClass]="{'active': activeLink === 'vastservice' || activeLink === 'creative' || activeLink === 'vastDetails'}" >
		<a [routerLink]="['/adservices/vastservice']"><i class="fa fa-cloud-upload"></i>{{ 'VAST_SERVICE' | translate }}</a>
	</li>
</ul>
